import React, { useState, useCallback, useEffect, useMemo } from "react"

import { OptionalLabelContext } from "context/OptionalLabelContext"

interface FieldLabelSpace {
  hasSpaceForLabel: boolean
}

type FieldStatuses = Record<string, FieldLabelSpace>

export const OptionalLabelManager = ({ children }: React.PropsWithChildren) => {
  const [showOptionalTags, setShowOptionalTags] = useState<boolean>(true)
  const [fieldStatuses, setFieldStatuses] = useState<FieldStatuses>({})

  const registerField = useCallback(
    (fieldId: string, hasSpaceForLabel: boolean) => {
      setFieldStatuses(prev => ({ ...prev, [fieldId]: { hasSpaceForLabel } }))
    },
    []
  )

  const unregisterField = useCallback((fieldId: string) => {
    setFieldStatuses(prev => {
      const newStatuses = { ...prev }
      delete newStatuses[fieldId]
      return newStatuses
    })
  }, [])

  useEffect(() => {
    const allFieldsHaveSpace = Object.values(fieldStatuses).every(
      field => field.hasSpaceForLabel
    )
    setShowOptionalTags(allFieldsHaveSpace)
  }, [fieldStatuses])

  const contextValue = useMemo(
    () => ({
      showOptionalTags,
      registerField,
      unregisterField
    }),
    [showOptionalTags, registerField, unregisterField]
  )

  return (
    <OptionalLabelContext.Provider value={contextValue}>
      {children}
    </OptionalLabelContext.Provider>
  )
}
